import {useEffect, useState } from 'react';
import { Observable, Subject } from 'rxjs';

function useStoreLoader<ActionInput, StoreValue>(
  action$: Subject<ActionInput>,
  store$: Observable<StoreValue>
) {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const actionSubscription = action$.subscribe(() => {
      setIsLoading(true);
    });
    return () => {
      if (actionSubscription) {
        actionSubscription.unsubscribe();
      }
    };
  }, [action$, setIsLoading]);

  useEffect(() => {
    const storeValueSubscription = store$.subscribe(() => {
      setIsLoading(false);
    });
    return () => {
      if (storeValueSubscription) {
        storeValueSubscription.unsubscribe();
      }
    };
  }, [store$, setIsLoading]);

  return {
    isLoading
  };  
}

export default useStoreLoader;